import React from 'react';
import styled from 'styled-components';

import { Event } from '../../interfaces';
import { EventThumb } from './eventThumb';

interface Props {
  event: Event;
  className?: string;
  width?: number;
  height?: number;
}

export function Thumbnail(props: Props) {
  const { event } = props;

  return (
    <StyledEventThumb
      event={event}
      eager
      onClick={() => false}
      width={props.width ? `${props.width}px` : '255px'}
      height={props.height ? `${props.height}px` : '141px'}
      className={`${props.className} hdn-event-thumbnail`}
      enableLicensePlates={false}
    />
  );
}

const StyledEventThumb = styled(EventThumb)`
  object-fit: contain;
  border-radius: 4px;
  overflow: hidden;
  display: inline-block;
  margin: 0;
`;
